import PropTypes from 'prop-types';
import { EmergencyContactShape } from './EmergencyContact';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const Jurisdiction = {
  zoneId: PropTypes.string,
  geometry: MapGeometryShape,
  emergencyContacts: PropTypes.arrayOf(EmergencyContactShape),
};

export const JurisdictionShape = PropTypes.shape(Jurisdiction);
export const JurisdictionExact = PropTypes.exact(Jurisdiction);
